export const CLIENT_SEARCH_OPTIONS = [
  { label: "거래처명", value: "name" },
  { label: "거래처코드", value: "code" },
  { label: "대표자명", value: "ceoName" },
  { label: "사업자등록번호", value: "comNum" },
  { label: "법인등록번호", value: "regNum" },
]

export const CLIENT_TYPES = [
  { label: "사업자", value: "0" },
  { label: "개인", value: "1" },
  { label: "외국인", value: "2" },
]

export const CLIENT_COMPANY_TYPES = [
  { label: "법인", value: "0" },
  { label: "개인", value: "1" },
]

export const CLIENT_USE_OPTIONS = [
  { label: "사용", value: "1" },
  { label: "중지", value: "0" },
]
